<h2 mat-dialog-title>Share this {{ label }}</h2>

<mat-dialog-content>
  <p class="stw-preview" *ngIf="data.preview">&ldquo;{{ data.preview }}&rdquo;</p>

  <div class="stw-loading" *ngIf="loading">
    <mat-spinner diameter="24"></mat-spinner>
  </div>

  <ng-container *ngIf="!loading">
    <p class="stw-empty" *ngIf="!workspaces.length">
      You do not have a shared workspace yet. Create one under <strong>Shared</strong> first,
      then come back.
    </p>

    <ng-container *ngIf="workspaces.length">
      <p class="stw-intro">
        Anyone you have invited to these workspaces will be able to read it.
      </p>
      <div class="stw-option" *ngFor="let ws of workspaces">
        <mat-checkbox [(ngModel)]="selected[ws.workspaceId]" [disabled]="busy">
          {{ ws.name }}
          <span class="stw-count">{{ ws.memberCount || 1 }} {{ (ws.memberCount || 1) === 1 ? 'person' : 'people' }}</span>
        </mat-checkbox>
      </div>
      <p class="stw-note">
        This replaces wherever it is shared now &mdash; whatever you leave unticked, it will not be
        shared into. Unticking everything takes it back entirely.
      </p>
    </ng-container>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="busy">Cancel</button>
  <button mat-raised-button color="primary" class="btn-send clr-white"
    (click)="save()" [disabled]="busy || loading || !workspaces.length">
    {{ chosen.length ? 'Share' : 'Stop sharing' }}
  </button>
</mat-dialog-actions>
